export default "__VITE_ASSET__PCa3KXF$__"